import React, { useState, useEffect, useCallback, useMemo } from "react";

import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import {
  inputName,
  inputId
} from '../../../helper/form';

import Select from 'react-select';

import FieldError from '../../../helper/FieldError';

import {
  routes,
  createService,
  updateService
} from './utils';

const DistributionListFilterModalForm = props => {
  const formName = 'bulk_datatable_distribution_list_filter';

  const {
    dataTable,
    modalIsOpen,
    filters,
    callbacks: {
      onSetModalIsOpen,
      onSetDistributionList,
      onFetchDistributionLists,
      onApplyFilters
    },
    configuration: {
      context
    }
  } = props;

  const [distributionList, setDistributionList] = useState({name: '', filters: []})

  useEffect(() => {
    let _filters = []

    if(_.isObject(props?.distributionList?.filters)){
      _.each(props?.distributionList?.filters, (value, key) => {
        _filters.push({field: key, value: value});
      })
    }

    setDistributionList(
      { ... props?.distributionList, filters: _filters }
    );
  }, [props?.distributionList])

  useEffect(() => {
    if(_.isEmpty(distributionList?.filters)){
      onAddItem();
    }
  }, [])

  const urls = useMemo(() => {
    try{
      return routes[context](props) || {};
    } catch(error){
      return {};
    }
  }, [context]);

  const {
    defaultRequestParams,
    createRoute,
    updateRoute
  } = urls;

  const saveService = useMemo(() => {
    return distributionList?.id ? updateService : createService;
  }, [distributionList?.id]);

  useEffect(() => {
    onApplyFilters(distributionList.filters);
  }, [distributionList.filters])

  const onAddItem = () => {
    setDistributionList(prevState => {
      return {
        ...prevState,
        filters: [...prevState.filters, {field: '', value: ''}]
      }
    })
  }

  const onRemoveItem = (index) => {
    setDistributionList(prevState => {
      return {
        ...prevState,
        filters: _.filter(prevState.filters, (filter, i) => {
          return i != index;
        })
      }
    })
  }

  const onChangeFieldItem = (event, index) => {
    const value = event?.value || '';

    setDistributionList(prevState => {
      return { ... prevState,
        filters: _.map(prevState.filters, (filter, i) => {
          if(i == index){
            filter = { ... filter, field: value }
          }
          return filter;
        })
      }
    })
  }

  const onChangeValueItem = (event, index) => {
    const value = event.target.value || '';

    setDistributionList(prevState => {
      return { ... prevState,
        filters: _.map(prevState.filters, (filter, i) => {
          if(i == index){
            return { ... filter, value: value }
          } else {
            return filter;
          }
        })
      }
    })
  }

  const onChangeName = (event) => {
    let value = event.target.value || '';

    setDistributionList(prevState => {
      prevState.name = value
      return { ... prevState }
    })
  }

  const filterFormData = () => {
    let formData =  new FormData();
    formData.append(inputName(formName, 'name'), distributionList.name);

    _.each(distributionList.filters, (filter, index) => {
      formData.append(`${formName}[filters][${filter.field}]`, filter.value);
    });

    return formData;
  }

  const onSave = event => {
    event.preventDefault();
    const formData = filterFormData();
    let requestParams = { ... defaultRequestParams, ...{ id: distributionList?.id, _options: true } };
    let route = distributionList?.id ? updateRoute : createRoute;

    saveService(route(requestParams), formData).then(response => {
      if(response.status == 200 || response.status == 201){
        let action = response.status == 200 ? 'update' : 'create';
        onFetchDistributionLists()
        onSetModalIsOpen(false);
        onSetDistributionList(response.data);

        swal.fire({
          position: 'center',
          icon: 'success',
          title: I18n.t(`bulk.datatable.distribution_list_filters.${action}.successfully`),
          showConfirmButton: true,
        })
      }
    }).catch(error => {
      if(error.response.status == 422){
        setDistributionList(prevState => {
          return { ... prevState, errors: error.response.data.errors }
        })

        swalToastBootstrap.fire({
          icon: 'error',
          title: I18n.t('bulk.distribution_list_filters.save.error')
        })
      }
    })
  }

  return(
    <Modal
      isOpen={ modalIsOpen }
      toggle={ () => onSetModalIsOpen(false) }
      size='lg'
      unmountOnClose={ true }
    >
      <Form onSubmit={ onSave }>
        <ModalHeader toggle={ () => onSetModalIsOpen(false) }>
          <i className="fas fa-cog mr-2"></i>
          { I18n.t('controldoc.datatable.distribution_list_filter.modal.title') }
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <FieldError errors={ _.get(distributionList, 'errors.name', []) }>
            <Label
              for={ inputId(formName, 'name') }
            >
              { I18n.t('activerecord.attributes.bulk/datatable/distribution_list_filter.name') }
            </Label>
            <Input
              type="text"
              id={ inputId(formName, 'name') }
              name={ inputName(formName, 'name') }
              value={ distributionList?.name || '' }
              onChange={ event => onChangeName(event) }
              invalid={ _.has(distributionList, 'errors.name') }
            />
            </FieldError>
          </FormGroup>

          <Card className='bg-real-light'>
            <CardHeader>
              <div className='d-flex justify-content-between'>
                <dt>Filtros que se aplicarán para la lista de distribución</dt>
                <dt>
                  <Button
                    color='success'
                    size='sm'
                    outline={ true }
                    onClick={ onAddItem }
                  >
                    Añadir filtro
                  </Button>
                </dt>
              </div>
            </CardHeader>
            <CardBody>
              { _.get(distributionList, 'errors.filters', []).length > 0 && (
                <div className="alert alert-danger">
                  <ul className="mb-0">
                    { _.map(_.get(distributionList, 'errors.filters', []), (error, index) => (
                      <li key={ `error-${ index }` }>{ error }</li>
                    ))}
                  </ul>
                </div>
              )}
              <Table>
                <thead>
                  <tr>
                    <th>Nombre del campo</th>
                    <th>Valor del campo</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  { _.map(distributionList?.filters || [], (filter, index)=> {
                    return (
                      <DistributionListFilterItemForm
                        key={ `DistributionListFilterItemForm-${ index }` }
                        filter={ filter }
                        dataTable={ dataTable }
                        index={ index }
                        callbacks={{
                          onRemoveItem,
                          onChangeFieldItem,
                          onChangeValueItem
                        }}
                      />
                    )
                  })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            color='default'
            onClick={ () => onSetModalIsOpen(false) }
          >
            { I18n.t('actions.close') }
          </Button>

          <Button
            type='submit'
            color='success'
          >
            { I18n.t('actions.save') }
          </Button>
        </ModalFooter>
      </Form>
    </Modal>

  )
}

export default DistributionListFilterModalForm;

const DistributionListFilterItemForm = props => {
  const {
    filter,
    dataTable,
    index,
    callbacks: {
      onRemoveItem,
      onChangeFieldItem,
      onChangeValueItem
    }
  } = props;

  const columns = dataTable?.current?.props?.columns || [];

  const currentColumn = useMemo(() => {
    return _.find(columns, column => column.field === filter.field) || null;
  }, [filter.field])

  const enabledFilterColumns = useMemo(() => {
    return _.filter(columns, column => column?.filter?.enabled) || [];
  }, [columns])

  // ========== START SELECT FIELD ITEM OPTIONS ==========
  const fieldItemSelectOptions = () => {
    return _.map(enabledFilterColumns, column => {
      return {
        label: column.header,
        value: column.field,
      }
    })
  }

  const fieldItemSelectedOption = () => {
    return _.find(fieldItemSelectOptions(), option => option.value === filter.field) || null;
  }
  // ========== END SELECT OPTIONS ==========

  // ========== START VALUE ITEM SELECT OPTIONS ==========
  const valueItemSelectedOption = () => {
    return _.find(currentColumn?.filter?.options, option => {
      return String(option.value) == String(filter.value);
    });
  }

  const valueItemInput = () => {
    const inputType = currentColumn?.filter?.inputType

    if(inputType == 'simple_select'){
      return (
        <Select
          options={ currentColumn?.filter?.options }
          placeholder="Selecciona un campo"
          value={valueItemSelectedOption() }
          onChange={ event => onChangeValueItem({target: { value: event.value }}, index) }
        />
      )
    } else {
      return (
        <Input
          type="text"
          placeholder="Valor del campo"
          onChange= { event => onChangeValueItem(event, index) }
          value={ filter.value }
        />
      )
    }
  }
  // ========== END VALUE ITEM SELECT OPTIONS ==========

  return(
    <tr>
      <td>
        <Select
          options={ fieldItemSelectOptions() }
          placeholder="Selecciona un campo"
          value={ fieldItemSelectedOption() }
          isClearable={ true }
          onChange={ event => onChangeFieldItem(event, index) }
        />
      </td>
      <td>
        <FormGroup>
          { valueItemInput() }
        </FormGroup>
      </td>
      <td>
        <Button
          color='danger'
          size='sm'
          outline={ true }
          onClick={ () => onRemoveItem(index) }
        >
          <i className="fas fa-trash"></i>
        </Button>
      </td>
    </tr>
  )
}
